import { render, staticRenderFns } from "./MasterReferences.vue?vue&type=template&id=189e242f&"
import script from "./MasterReferences.vue?vue&type=script&lang=js&"
export * from "./MasterReferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports